import React from "react";
import './Team.css';

const Team = () => {
      return (
            <div>
                  <section className="teamSection">
                        <div className="teamTitle">
                              <h3>Meet Our Team Members</h3>
                        </div>
                <div className="teamGrid">
                    <div className="teamMember">
                        <img src="/Mentor.png" alt="Mentor" />
                        <p className="cBlack">Emmanuel Daniel</p>
                        <p className="cWhite">Mentor</p>
                    </div>
                    <div className="teamMember">
                        <img src="/Juliana A..png" alt="Team Member" />
                        <p className="cBlack">Juliana Akpaette</p>
                        <p className="cYellow">Product Manager</p>
                    </div>
                    <div className="teamMember">
                        <img src="/Juliana A-Martins.png" alt="Team Member" />
                        <p className="cBlack">Juliana Adeniyi-Martins</p>
                        <p className="cYellow">Product Manager</p>
                    </div>
                    <div className="teamMember">
                        <img src="/Justina Olayemi.png" alt="Team Member" />
                        <p className="cBlack">Justina Olayemi</p>
                        <p className="cYellow">Product Manager</p>
                    </div>
                    <div className="teamMember">
                        <img src="/Kidstemariam K.png" alt="Team Member" />
                        <p className="cBlack">Kidstemariam Kidane</p>
                        <p className="cYellow">Product Manager</p>
                    </div>
                    <div className="teamMember">
                        <img src="/Toyibat Salako.png" alt="Team Member" />
                        <p className="cWhite">Toyibat Salako</p>
                        <p className="cBlack">Product Designer</p>
                    </div>
                    <div className="teamMember">
                        <img src="/Tracy O..png" alt="Team Member" />
                        <p className="cBlack">Tracy Omoike</p>
                        <p className="cGreen">Data Analyst</p>
                    </div>
                    <div className="teamMember">
                        <img src="/Uchenna O..png" alt="Team Member" />
                        <p className="cBlack">Uchenna Okafor</p>
                        <p className="cGreen">Data Analyst</p>
                    </div>
                    <div className="teamMember">
                        <img src="/Sylvie's Selfie.jpeg" alt="Team Member" />
                        <p className="cWhite">Sylvie SHIMWA UWASE</p>
                        <p className="cBlue">Front-End Developer</p>
                    </div>
                    <div className="teamMember">
                        <img src="/Temilola.jpeg" alt="Team Member" />
                        <p className="cWhite">Temilola Oguntamu</p>
                        <p className="cBlue">Front-End Developer</p>
                    </div>
                    <div className="teamMember">
                        <img src="/Roberta O..png" alt="Team Member" />
                        <p className="cYellow">Roberta Okorie</p>
                        <p className="cPink">Cyber Security</p>
                    </div>
                    <div className="teamMember">
                        <img src="/Tolulope A..png" alt="Team Member" />
                        <p className="cBlue">Tolulope Adesanya</p>
                        <p className="cRed">Back-End Developer</p>
                    </div>
                    <div className="teamMember">
                        <img src="/Faith M..png" alt="Team Member" />
                        <p className="cBlack">Faith Madamedon</p>
                        <p className="cGreen">Data Analyst</p>
                    </div>
                    <div className="teamMember">
                        <img src="/Oluwadamilola.png" alt="Team Member" />
                        <p className="cBlack">Oluwadamilola Ogunmodede</p>
                        <p className="cYellow">Product Manager</p>
                    </div>
                        </div>
                  </section>
            </div>
      );
};

export default Team;